const sizeVariants = {
    small: {
      width: "100px",
      height: "30px",
      size: "14px",
    },
    medium: {
      width: "150px",
      height: "40px",
      size: "16px",
    },
    large: {
      width: "200px",
      height: "50px",
      size: "18px",
    },
  };
  
  export default sizeVariants;
  